import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  public baseUrl: string =
  'https://hoteldirect-new-backend-devtest.azurewebsites.net/api/v1';// 'https://hoteldirect-backend-new-production-preprod.azurewebsites.net/api/v1';

  constructor() {
    this.setBaseUrl();
  }

  
  public setBaseUrl(): void {
    if (
      window.location.hostname == 'staysconnect.com' ||
      window.location.hostname == 'www.staysconnect.com'
    ) {
      this.baseUrl =
        'https://hoteldirect-backend-new-production.azurewebsites.net/api/v1';
    } else if (
      window.location.hostname == 'hoteldirect-web-devtest.azurewebsites.net' ||
      window.location.hostname ==
        'www.hoteldirect-web-devtest.azurewebsites.net' || window.location.hostname == 'localhost'
    ) {
      this.baseUrl = 'https://hoteldirect-new-backend-devtest.azurewebsites.net/api/v1';
      //'https://wakanow-hotels-backend-prod.azurewebsites.net/api/v1';
        
    } else {
      this.baseUrl =
        'https://hoteldirect-backend-new-production-preprod.azurewebsites.net/api/v1';
    }
  }
}

//'https://hoteldirect-backend-production-prod.azurewebsites.net/api/v1/
//'https://hoteldirect-backend-production-preprod.azurewebsites.net/api/v1/'

//https://hoteldirect-new-backend-devtest.azurewebsites.net/admin - dev
//https://hoteldirect-backend-new-production-preprod.azurewebsites.net/admin - preprod
//https://hoteldirect-backend-new-production.azurewebsites.net/admin
